import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">The Trust Ladder</div>
                                            <p>Use the ladder – showing the sorts of behaviour that builds or
                                                loses trust – to reflect on how often you behave in ways that
                                                both win and lose trust. What do you do well? What opportunities
                                                does it reveal for you to improve your trust building
                                                skills?</p>

                                            <div className="innovativeimg">
                                                <img
                                                    src={require('@images/ladder-image.jpg')}
                                                    style={{width:'100%'}}/>
                                            </div>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page3')}
                                                    className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}